export default __webpack_public_path__ + "static/media/pokedex3.f4aea2f8.jpg";